const options = {
  5: "bg-stone-600/5",
  10: "bg-stone-600/10",
  25: "bg-stone-600/25",
  50: "bg-stone-600/50",
  75: "bg-stone-600/75",
  90: "bg-stone-600/90",
  100: "bg-stone-600",
};

const from = {
  5: "from-stone-600/5",
  10: "from-stone-600/10",
  25: "from-stone-600/25",
  50: "from-stone-600/50",
  75: "from-stone-600/75",
  90: "from-stone-600/90",
  100: "from-stone-600",
};

export default function getBackgroundStone600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
